<template>
  <div>
    <heading>
      <small>Updated privacy notice</small>
    </heading>

    <p>
    Hi there, we've made some changes since the last time you were here:
    </p>

    <ul class="privacy-update-list">
      <li v-for="update in updates">
        <div class="privacy-update-date">{{ update.date }}:</div>
        <p v-for="text in update.notice">
        {{ text }}
        </p>
      </li>
    </ul>

    <p>
    Please have a look at the full privacy notice below to learn about how we
    handle your personal information and consent to our updated practices before
    you continue to use WElix.
    </p>

    <hr class="rule">

    <consent-form @submit="saveConsent">
    </consent-form>

    <form-button pull="left"
                 @click="$router.push('/')">
      Cancel
    </form-button>

    <div class="spacer"></div>

    <form-message v-if="error"
                  severity="warning"
                  :message="error"/>
  </div>
</template>

<script>
import { getConsentDate, setConsentDate } from '../auth';
import { privacyNoticeUpdates } from '../config';

import Heading from './elements/Heading';
import FormButton from './elements/FormButton';
import FormMessage from './elements/FormMessage';

import ConsentForm from './forms/Consent';

export default {
  components: {
    Heading,
    FormButton,
    FormMessage,
    ConsentForm,
  },

  created() {
    getConsentDate((date) => {
      this.last_consent_date = date;
    });
  },

  data() {
    return {
      last_consent_date: '9999',
      error: null,
    };
  },

  computed: {
    updates() {
      return privacyNoticeUpdates.filter(x =>
          !this.last_consent_date || x.date > this.last_consent_date);
    },
  },

  props: {
    redirect: { type: String, default: '/' },
  },

  methods: {
    saveConsent({ consentDate }) {
      setConsentDate({
        consent_date: consentDate,
        success: () => this.$router.replace(this.redirect),
        error: (err) => { this.error = err; },
      });
    },
  },
};
</script>

<style scoped>
.privacy-update-list {
  list-style: none;
  padding-left: 1em;
  font-size: 85%;
}
.privacy-update-list .privacy-update-date {
  margin-left: -1em;
  margin-right: .5em;
  float: left;
  font-weight: bold;
}

.rule {
  margin: 30px 0 20px;
  border: 9px none transparent;
  border-top: 1px solid #cacaca;
  border-bottom: 1px solid #e9e9e9;
}
.spacer {
  clear: both;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AskConsent.vue